import React, { useState, useEffect } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import tableIcons from './tableIcons';
import ReactPaginate from 'react-paginate';
import VisibilityIcon from '@material-ui/icons/RemoveRedEyeOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import SearchIcon from '@material-ui/icons/Search';
import Grid from '@material-ui/core/Grid';
import './TableStyle.css';


import API from '../../../utils/api';

const getActions = {
  view: (action) => ({
    icon: () => <VisibilityIcon color="secondary" fontSize="small" />,
    tooltip: 'View',
    onClick: (event, rowData) => { action(rowData) }
  }),
  delete: (action) => ({
    icon: () => <DeleteOutlineIcon color="secondary" fontSize="small" />,
    tooltip: 'Delete',
    onClick: (event, rowData) => action(rowData)
  }),
  edit: (action) => ({
    icon: () => <EditOutlinedIcon color="secondary" fontSize="small" />,
    tooltip: 'Edit',
    onClick: (event, rowData) => action(rowData)
  })
}

const Table = ({ classes, url, onPageChange, isLoading = false, title = "", tableConfig, data, onView, onDelete, onEdit, onVerify, noBorder = false, globalSearch = false, filtering = true, key, apidata, countryid, btnlabel, detailPanel }) => {

  console.log("key---->",key)
  const [config, setConfig] = useState([]);
  const [localization, setLocale] = useState({});
  let actions = [];
  if (onView) {
    actions = [...actions, getActions.view(onView)];
  }
  if (onEdit) {
    actions = [...actions, getActions.edit(onEdit)];
  }
  if (onDelete) {
    actions = [...actions, getActions.delete(onDelete)];
  }


  const filterComponent = (props) => {
    return (<div>
      <input type="text" placeholder="Search" className={classes.filter} onChange={
        (e) => props.onFilterChanged(props.columnDef.tableData.id, e.target.value)
      } /></div>)
  };

  useEffect(() => {
    if (tableConfig && tableConfig.columns) {
      const configuration = tableConfig.columns.map((configItem) => {
        return {
          ...configItem,
          sorting: configItem.filterAndSearch,
          filtering: configItem.filterAndSearch,
          filterPlaceholder: 'Search',
          searchable: configItem.filterAndSearch
        }
      });
      setConfig(configuration);
    }
  }, [tableConfig]);

  return (
    <MaterialTable
      style={{ width: '100%', boxShadow: 'none', background: 'white', padding: '15px', borderRadius: noBorder ? '0px' : '5px' }}
      localization={localization}
      icons={tableIcons}
      actions={actions}
      columns={config}
      //data={data}
      title={title}
      isLoading={isLoading}

      options={
        {
          // exportButton: {
          //   csv: true,
          //   pdf: true
          // },
          // toolbar: globalSearch,
          filtering: filtering,
          //search:false,
          //columnsButton: false,
          exportAllData: true,
          exportButton: true,
          sorting: true,
          hideFilterIcons: true,
          actionsColumnIndex: -1,
          tableLayout: 'fixed',
          searchFieldAlignment: 'left',
          pageSize: 5,
          paginationType: 'stepped',
          pageSizeOptions: [],
          headerStyle: {
            backgroundColor: '#f58634',
            color: 'white',
            padding: '8px 0 8px 16px',
          },
          filterCellStyle: {
            backgroundColor: '#fef3ea',
            padding: '8px 0 8px 16px',
          },
          searchFieldStyle: {
            borderRadius: '20px',
            border: '1px solid grey',
            padding: '5px 35px',
            marginBottom: '10px',
            display: "none"
          }
        }
      }

      data={url ? query =>
        new Promise((resolve, reject) => {
          //console.log("apiquery",query);
          setLocale({ body: { emptyDataSourceMessage: '' } });
          let filters = [];
          let painationProps = [`recordsPerPage=5`, `pageNo=${query.page + 1}`];
          //let cntry =[`countryId=${countryid}&settlementsFor=afterLastSettlement`];

          if (query.filters.length > 0) {
            filters = query.filters.map(filter => `${filter.column.field}=${filter.value}`);
          }
          let apiUrl = `${url}&`;
          let newdata = "";

          apiUrl += [...filters, ...painationProps].join('&');
          //console.log("apiurl",apiUrl);
          API.get(apiUrl)
            .then(response => {
              let result = response.data || {};
              if (apidata === "records") {
                newdata = result.details.records
              }

              resolve({
                data: newdata,
                page: result.details.pageNo - 1,
                totalCount: result.details.totalRecords,

              })
              setLocale({ body: { emptyDataSourceMessage: isLoading ? '' : 'No Records found' } });
            })
        }) : data
      }
      detailPanel={rowData => {
        return (
          <div>
            <Grid item xs={12} style={{ marginBottom: "20px" }}>
              <div className="row">
                <Grid item xs={6}>
                  <div className="row" style={{ marginLeft: '20px' }}>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={11}><strong>Bank Details</strong></Grid>
                    </Grid>
                  </div>
                  <div className="row" style={{ marginLeft: '20px' }}>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={4}>Account Holder Name</Grid>
                      <Grid item xs={1}>:</Grid>
                      <Grid item xs={5}>{rowData.accountHolderName}</Grid>
                    </Grid>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={4}>Bank Name</Grid>
                      <Grid item xs={1}>:</Grid>
                      <Grid item xs={5}>{rowData.bankName}</Grid>
                    </Grid>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={4}>Account Number</Grid>
                      <Grid item xs={1}>:</Grid>
                      <Grid item xs={5}>{rowData.accountNumber}</Grid>
                    </Grid>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={4}>Bank Code</Grid>
                      <Grid item xs={1}>:</Grid>
                      <Grid item xs={5}>{rowData.bankCode}</Grid>
                    </Grid>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={4}>Date Of Transfer</Grid>
                      <Grid item xs={1}>:</Grid>
                      <Grid item xs={5}>{rowData.dateOfTransfer} {rowData.timeOfTransfer}</Grid>
                    </Grid>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={4}>Reference ID</Grid>
                      <Grid item xs={1}>:</Grid>
                      <Grid item xs={5}>{rowData.referenceId}</Grid>
                    </Grid>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={4}>Transfer Status</Grid>
                      <Grid item xs={1}>:</Grid>
                      <Grid item xs={5}>{rowData.transferStatu}</Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className="row" style={{ marginLeft: '10px', marginBottom: '10px' }}>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={12}><strong>Transfer Details</strong></Grid>
                    </Grid>
                  </div>
                  <div className="row" style={{ marginLeft: '10px' }}>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={5}>Transfer ID</Grid>
                      <Grid item xs={1}>:</Grid>
                      <Grid item xs={4}>{rowData.transferId}</Grid>
                    </Grid>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={5}>Unadjusted Previous Extra Received</Grid>
                      <Grid item xs={1}>:</Grid>
                      <Grid item xs={4}>{(rowData.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{rowData.unAdjustedPreviousExtraReceived}</Grid>
                    </Grid>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={5}>Pending Amount Adjusted</Grid>
                      <Grid item xs={1}>:</Grid>
                      <Grid item xs={4}>{(rowData.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{rowData.pendingAmountAdjusted}</Grid>
                    </Grid>
                    <Grid container spacing={2} className={'mt-3 '}>
                      <Grid item xs={5}>Mode Of Transfer</Grid>
                      <Grid item xs={1}>:</Grid>
                      <Grid item xs={4}>{rowData.modeOfTransfer}</Grid>
                    </Grid>
                  </div>
                </Grid>
              </div>
            </Grid>
          </div>
        )
      }}
      onRowClick={(event, rowData, togglePanel) => togglePanel()}
    />
  );
};

export default Table;
